<template>
  <div class="searchBar">
    <a-form>
      <!-- 只有店群模式时才展示 -->
      <a-form-item v-if="mallGroupId && mallList?.length" label="店铺">
        <a-select v-model:value="formState.relationId" style="width: 140px" @change="search">
          <a-select-option v-for="item of mallList" :value="item.Id" :key="item.Id">
            {{ item.auth?.ShopName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="商品标题">
        <a-input
          v-model:value="formState.goodsName"
          placeholder="请输入商品标题"
          allowClear
          style="width: 150px"
          @keydown.enter="search"
        />
      </a-form-item>
      <a-form-item label="订单编号">
        <a-input v-model:value="formState.OrderId" placeholder="请输入订单编号" allowClear @keydown.enter="search" />
      </a-form-item>
      <a-form-item label="拍单订单号">
        <a-input
          v-model:value="formState.purchasedOrderId"
          placeholder="请输入拍单订单号"
          allowClear
          @keydown.enter="search"
        />
      </a-form-item>
      <a-form-item label="拍单时间">
        <a-select v-model:value="dateTime" style="width: 90px" @change="selectCheckedDate">
          <a-select-option value="DIY">自定义</a-select-option>
          <a-select-option v-for="item in dateTimeList" :key="item.timeStamp" :value="item.timeStamp">{{
            item.timeName
          }}</a-select-option>
        </a-select>
        <a-range-picker
          style="width: 210px"
          v-model:value="timeSpace"
          :disabledDate="disabledDate"
          format="yyyy-MM-DD HH:mm:ss"
          :allowClear="false"
          @change="pickerChange"
        />
      </a-form-item>
      <a-space>
        <a-button type="primary" @click="search">搜索</a-button>
        <ExportBtn
          key="shot_list"
          :GetExportItemList="checkedItems"
          :myConfigs="myExportConfig"
          :isShowCSV="false"
          :isShowExportText="false"
          :isCustomExport="selectExportOrderType === 'select-time'"
          :customGetList="selectExportOrderType === 'select-time' ? customGetList : null"
        >
          <template #top-content>
            <a-space style="margin-bottom: 12px">
              筛选条件:
              <a-radio-group v-model:value="selectExportOrderType" button-style="solid">
                <a-radio-button value="check-order">根据勾选的订单</a-radio-button>
                <a-radio-button value="select-time">根据选择的拍单时间</a-radio-button>
              </a-radio-group>
            </a-space>
          </template>
        </ExportBtn>
      </a-space>
    </a-form>
  </div>
</template>
<script>
import handler from "./handler";
import moment from "moment";
import ExportBtn from "@/views/base/components/export_btn";
import indexHandler from "../../handler";
import { mapGetters } from "vuex";
var myExportConfig = handler.GetMyExportConfig();
export default {
  props: {
    selectedRows: Array,
    mallGroupId: {},
  },
  computed: {
    ...mapGetters({
      checkMall: "mall_group/checkMall",
    }),
  },
  data() {
    return {
      formState: {
        OrderId: "",
        purchasedOrderId: "",
        relationId: null,
      },
      timeSpace: [moment("2015/01/03", "yyyy-MM-DD HH:mm:ss"), moment("2015/01/03", "yyyy-MM-DD HH:mm:ss")],
      dateTimeList: [],
      dateTime: "",
      myExportConfig,
      selectExportOrderType: "check-order",
      mallList: [],
      localKey: "xf_zfb_buy_list_purchasedOrder_chengtuanTimeIndex",
    };
  },
  components: { ExportBtn },
  methods: {
    disabledDate(current) {
      return current && current > moment().endOf("day");
    },
    checkedItems() {
      return this.selectedRows;
    },
    selectCheckedDate(value) {
      this.dateTimeList.forEach((item, index) => {
        if (item.timeStamp == value) localStorage.setItem(this.localKey, index);
      });
      const { startTime, endTime } = handler.checkTimeShow(value);
      this.timeSpace = [moment(startTime), moment(endTime)];
      //这里将时间间隔数组复制一份
      this.ridioTimeSpace = this.timeSpace;
      this.timeFormatHandler();
    },
    pickerChange() {
      //时间框和快捷时间按钮双向绑定
      this.dateTime = handler.radioButtonVmodel(this.timeSpace);
      this.timeFormatHandler();
    },
    initializePicker() {
      //初始化时间戳间隔数组
      this.dateTimeList = handler.dataTimeList;
      if (localStorage.getItem(this.localKey))
        this.dateTime = this.dateTimeList[localStorage.getItem(this.localKey)].timeStamp;
      else this.dateTime = this.dateTimeList[3].timeStamp; // 默认是近7天
      const { startTime, endTime } = handler.checkTimeShow(this.dateTime);
      this.timeSpace = [moment(startTime), moment(endTime)];
    },
    timeFormatHandler() {
      const { orderInfoStartTime, orderInfoEndTime } = handler.timeFormatHandler(this.timeSpace);
      this.formState.orderInfoStartTime = orderInfoStartTime;
      this.formState.orderInfoEndTime = orderInfoEndTime;
      this.search();
    },
    search() {
      this.$emit("searchOrderList", this.formState);
    },
    // 自定义导出数据，根据【拍单时间】
    async customGetList() {
      this.$message.loading("正在获取拍单数据中", 0);
      const { list } = await indexHandler.GetAllOrderList(this.mallGroupId, this.formState);
      this.$message.destroy();
      list?.length && this.$message.success(`已获取【${list.length}】个订单数据`);
      return { list, errMsg: list?.length ? "" : "选择的拍单时间段暂无数据，请修改拍单时间" };
    },
    // 只有是店群模式时才需要获取店铺列表
    async getMallList() {
      if (this.mallGroupId) {
        const { mallList } = await handler.GetMallList(this.mallGroupId);
        this.mallList = mallList;
        this.formState.relationId = mallList[0].Id;
        if (this.checkMall) {
          this.formState.relationId = this.checkMall.Id;
        }
      }
    },
  },
  async mounted() {
    this.initializePicker();
    await this.getMallList();
    this.timeFormatHandler();
  },
};
</script>
<style lang="less" scoped>
.searchBar {
  .ant-form {
    display: flex;
    flex-wrap: wrap;
    line-height: 3;
    :deep(.ant-form-item) {
      margin-right: 6px;
      margin-bottom: 0px;
      flex-wrap: nowrap;
      align-items: center;
      :deep(.ant-form-item-children) {
        display: flex;
      }
    }
  }
}
</style>
